import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=324bbc80"
import script from "./number-input.vue?vue&type=script&lang=js"
export * from "./number-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports